export default __webpack_public_path__ + "static/media/settings-icon-hover.447516f5.svg";